import classnames from "classnames"
import PropTypes from "prop-types"
import "./styles/StepCommentPreview.css"

const StepCommentPreview = function (
  { comment, completion, inverted },
  { user }
) {
  if (comment == null) {
    comment = completion != null ? completion.completion_comment : undefined
  }

  if (!comment) {
    return null
  }

  const notOwnComment =
    __guard__(completion != null ? completion.user : undefined, (x) => x.id) &&
    completion.user.id !== user.id
  const label = notOwnComment ? `${completion.user.first_name}'s` : "Your"
  const className = classnames("StepCommentPreview", {
    "StepCommentPreview--inverted": inverted
  })

  return (
    <div className={className}>
      <h6>{label} comment</h6>
      <p>"{comment}"</p>
    </div>
  )
}

StepCommentPreview.displayName = "StepCommentPreview"

StepCommentPreview.contextTypes = { user: PropTypes.object }

export default StepCommentPreview

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
